import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Check, AlertCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const txId = params.get("tx_id");
  const dismissed = params.get("dismissed") === "1";
  const navigate = useNavigate();
  const [state, setState] = useState("checking");

  useEffect(() => {
    let tries = 0;
    const maxTries = dismissed ? 2 : 10;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${txId}`);
        if (r.data.payment_status === "paid") { navigate(`/order-confirm/${r.data.order_number}?tx_id=${txId}`); return; }
        if (r.data.payment_status === "cancelled") { navigate(`/payment/cancel`); return; }
      } catch { /* keep polling */ }
      tries += 1;
      if (tries < maxTries) setTimeout(poll, 1500);
      else if (dismissed) navigate(`/payment/cancel`);
      else setState("timeout");
    };
    poll();
  }, [txId, dismissed, navigate]);

  return (
    <div className="min-h-screen bg-cream dot-grid flex items-center justify-center p-5">
      <div className="max-w-md text-center" data-testid="payment-success-checking">
        {state === "timeout" ? (
          <>
            <AlertCircle className="w-10 h-10 text-coral mx-auto" />
            <h1 className="font-display font-semibold text-2xl mt-4">We're still confirming your payment</h1>
            <p className="text-sm text-charcoal/70 mt-2">This usually takes a moment. Check Track Order in a minute — your order will appear once payment is confirmed.</p>
            <Link to="/track-order" className="inline-block mt-6 bg-forest text-white hover:bg-forest-dark px-6 py-3 rounded-full">Track order</Link>
          </>
        ) : (
          <>
            <Check className="w-10 h-10 text-forest mx-auto animate-pop" />
            <h1 className="font-display font-semibold text-2xl mt-4">Confirming your payment…</h1>
            <p className="text-sm text-charcoal/70 mt-2">Verifying with the gateway — one moment.</p>
          </>
        )}
      </div>
    </div>
  );
}
